import {
  CollabPresence,
  CollabUserClient,
} from "@vericus/cadmus-editor-prosemirror";

import { Presence } from "phoenix";

/**
 * Implementation of a collaborative ClientPresence tracking clients connected
 * to the Student Channel.
 *
 * Subscribes to the the Student Channel's Presence CRDT updates for changes
 * using `this.startSync()`. Metada shape is described in `PresenceMeta`.
 *
 * List of connected clients are accessed through `this.clients()`.
 */
export class LocalCollabPresence implements CollabPresence {
  state: CollabUserClient[] = [];
  presence: Presence;
  private listeners: ((clients: CollabUserClient[]) => void)[] = [];

  constructor(presence: Presence) {
    this.presence = presence;
  }

  /**  Get current list of connected clients **/
  clients() {
    return this.state;
  }

  /** Subscribe to presence updates - Everytime user list changes **/
  onUpdate(callback: (clients: CollabUserClient[]) => void) {
    this.listeners.push(callback);

    // Return unsubscribe
    return () => {
      this.listeners = this.listeners.filter((cb) => cb !== callback);
    };
  }

  /** Notify all listeners of presence update **/
  private notify() {
    for (const cb of this.listeners) {
      cb(this.state);
    }
  }

  startSync() {
    this.presence.onSync(() => {
      const clients: Record<string, CollabUserClient> = {};
      this.presence.list((_userId, { metas }: { metas: PresenceMeta[] }) => {
        for (const meta of metas) {
          if (meta.client) {
            clients[meta.client.client_id] = {
              clientId: meta.client.client_id,
              name: meta.client.name,
              colourset: meta.client.colourset,
              anchor: meta.client.selection?.anchor ?? null,
              head: meta.client.selection?.head ?? null,
            };
          }
        }
      });

      const clientList = Object.values(clients);
      this.state = clientList;
      this.notify();
    });
  }
}

/** Shape of presence metadata on the Work Channel. */
export interface PresenceMeta {
  client?: ClientMeta;
}

/** Client metadata part of a User's presence information.  */
export interface ClientMeta {
  client_id: string;
  colourset: number;
  name: string;
  selection?: {
    kind: "editor";
    stream_id: string;
    anchor: number;
    head: number;
  };
}
